<template>
  <div class="bg-light">

    <!-- BEGIN #about-us-cover -->
    <div id="about-us-cover" class="has-bg section-container">
      <!-- BEGIN cover-bg -->
      <div class="cover-bg">
        <img src="/beta/static/img/apps-dev/cover-3.jpg" alt="" />
      </div>
      <!-- END cover-bg -->
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN breadcrumb -->
        <!-- <ul class="breadcrumb m-b-10 f-s-12">
                    <li><a href="#">Home</a></li>
                    <li class="active">Apps Developer</li>
                </ul> -->
        <!-- END breadcrumb -->
        <!-- BEGIN about-us -->
        <div class="about-us text-center">
          <h1>womia for apps developer</h1>
        </div>
        <!-- END about-us -->
      </div>
      <!-- END container -->
    </div>
    <!-- END #about-us-cover -->

    <!-- BEGIN #about-us-content -->
    <div id="about-us-content" class="section-container bg-white">
      <!-- BEGIN container -->
      <div class="container">
        <!-- BEGIN about-us-content -->
        <div class="about-us-content">
          <h2 class="title text-center">What womia provides to the Apps Developer ?</h2>
          <p class="desc text-center">
            Dedicated APIs and web services for building, evaluating and monetizing Apps <br> order to target the right
            customers.

          </p>

          <!-- BEGIN row -->
          <div class="row">
            <!-- begin col-4 -->
            <div class="col-md-4 col-sm-4">
              <div class="service">
                <div class="icon text-success"><i class="fa fa-institution"></i></div>
                <div class="info">
                  <h4 class="title">Monetize Apps from your home office</h4>
                  <p class="desc">Make money on the Apps you have developed and follow-up their success using our APIs.
                  </p>
                </div>
              </div>
            </div>
            <!-- end col-4 -->
            <!-- begin col-4 -->
            <div class="col-md-4 col-sm-4">
              <div class="service">
                <div class="icon text-success"><i class="fa fa-dot-circle-o"></i></div>
                <div class="info">
                  <h4 class="title">Personalized Channel of distribution</h4>
                  <p class="desc">Show up your Apps and connect to targeted customers in one place.</p>
                </div>
              </div>
            </div>
            <!-- end col-4 -->
            <!-- begin col-4 -->
            <div class="col-md-4 col-sm-4">
              <div class="service">
                <div class="icon text-success"><i class="fa fa-bar-chart"></i></div>
                <div class="info">
                  <h4 class="title">Skip the marketing<br>process</h4>
                  <p class="desc">Focus on developping Apps and let us take care of the hassle of commercializing and
                    marketing your research.</p>
                </div>
              </div>
            </div>
            <!-- end col-4 -->
          </div>
          <!-- END row -->
          <hr>
          <!-- BEGIN row -->
          <div class="row">
            <!-- begin col-4 -->
            <div class="col-md-4 col-sm-4">
              <div class="service">
                <div class="icon text-success"><i class="fa fa-code"></i></div>
                <div class="info">
                  <h4 class="title">Build your Apps</h4>
                  <p class="desc">Turn your medical imaging algorithms to a reliable, accurate and rapid Apps using womia
                    APIs.</p>
                </div>
              </div>
            </div>
            <!-- end col-4 -->
            <!-- begin col-4 -->
            <div class="col-md-4 col-sm-4">
              <div class="service">
                <div class="icon text-success"><i class="fa fa-share-alt"></i></div>
                <div class="info">
                  <h4 class="title">Workflow integration</h4>
                  <p class="desc">Connect your App to well known third-party viewers /Pacs (Osirix & Horos) using womia
                    APIs.</p>
                </div>
              </div>
            </div>
            <!-- end col-4 -->
            <!-- begin col-4 -->
            <div class="col-md-4 col-sm-4">
              <div class="service">
                <div class="icon text-success"><i class="fa fa-check-square-o"></i></div>
                <div class="info">
                  <h4 class="title">Evaluate your Apps</h4>
                  <p class="desc">Connect to independent experts who assist you in the evaluation of your Apps without
                    exposing intellectual property.</p>
                </div>
              </div>
            </div>
            <!-- end col-4 -->
          </div>
          <!-- END row -->
        </div>
        <!-- END about-us-content -->
      </div>

      <!-- END container -->
    </div>
    <div class="bg-light">
      <footer-build-your-app></footer-build-your-app>
    </div>
    <!-- END #about-us-content -->
  </div>
</template>
<script>
import FooterBuildYourApp from '@/components/FooterBuildYourApp'
export default {
  components: {
    'footer-build-your-app': FooterBuildYourApp
  }
}
</script>

<style scoped>
.section-container {
  padding: 100px 0;
}

.page-header-cover:before {
  background: rgba(36, 42, 48, 0.5);
}

.page-header-cover img {
  max-width: 100%;
  width: 100%;
}</style>



// WEBPACK FOOTER //
// src/pages/public/AppsDev.vue